import React from 'react';
import { Calendar, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const MESES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

/**
 * Componente de filtro por mês com navegação
 */
export default function MonthFilter({ 
  selectedMonth, // formato: "2026-03"
  onChange,
  className = ""
}) {
  const currentDate = new Date();
  const [year, month] = selectedMonth ? selectedMonth.split('-').map(Number) : [currentDate.getFullYear(), currentDate.getMonth() + 1];

  const handlePrevMonth = () => {
    const newDate = new Date(year, month - 2, 1);
    onChange(`${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}`);
  };

  const handleNextMonth = () => {
    const newDate = new Date(year, month, 1);
    // Não permitir ir além do mês atual
    if (newDate <= currentDate) {
      onChange(`${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}`);
    }
  };

  const handleClear = () => {
    onChange('');
  };

  const isCurrentMonth = year === currentDate.getFullYear() && month === currentDate.getMonth() + 1;

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="month-filter">
      <div className="flex items-center gap-1 bg-white border rounded-lg px-2 py-1.5">
        <Calendar size={16} className="text-gray-400" />
        
        <Button
          variant="ghost"
          size="sm"
          onClick={handlePrevMonth}
          className="h-7 w-7 p-0"
          data-testid="month-prev"
        >
          <ChevronLeft size={16} />
        </Button>

        <span className="min-w-[140px] text-center text-sm font-medium text-gray-700">
          {MESES[month - 1]} {year}
        </span>

        <Button
          variant="ghost"
          size="sm"
          onClick={handleNextMonth}
          disabled={isCurrentMonth}
          className="h-7 w-7 p-0"
          data-testid="month-next"
        >
          <ChevronRight size={16} />
        </Button>
      </div>

      {selectedMonth && (
        <Button
          variant="outline"
          size="sm"
          onClick={handleClear}
          className="text-xs"
        >
          Ver todos
        </Button>
      )}
    </div>
  );
}

/**
 * Gera o primeiro e último dia de um mês no formato YYYY-MM-DD
 */
export function getMonthDateRange(monthStr) {
  if (!monthStr) return { startDate: null, endDate: null };
  
  const [year, month] = monthStr.split('-').map(Number);
  const startDate = `${year}-${String(month).padStart(2, '0')}-01`;
  const lastDay = new Date(year, month, 0).getDate();
  const endDate = `${year}-${String(month).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
  
  return { startDate, endDate };
}
